import { SVGProps, memo } from 'react'

const LogoImage = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    width={360}
    height={250}
    {...props}
  >
    <g clipPath="url(#a)">
      <rect width={360} height={250} fill="#051F51" fillOpacity={0.04} rx={16} />
      <g filter="url(#b)">
        <path
          fill="#fff"
          d="M12 24.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C18.08 12 20.32 12 24.8 12h310.4c4.48 0 6.721 0 8.432.872a8.002 8.002 0 0 1 3.496 3.496C348 18.08 348 20.32 348 24.8V250H12V24.8Z"
        />
        <path fill="url(#c)" d="M28 28h149v48H28z" />
        <rect width={86} height={10} x={28} y={98} fill="#051F51" fillOpacity={0.04} rx={4} />
        <rect width={239} height={10} x={28} y={123} fill="#051F51" fillOpacity={0.04} rx={4} />
        <rect width={285} height={10} x={28} y={185} fill="#051F51" fillOpacity={0.04} rx={4} />
        <rect width={207} height={10} x={28} y={141} fill="#051F51" fillOpacity={0.04} rx={4} />
        <rect width={239} height={10} x={28} y={203} fill="#051F51" fillOpacity={0.04} rx={4} />
        <rect width={112} height={10} x={28} y={159} fill="#051F51" fillOpacity={0.04} rx={4} />
        <rect width={203} height={10} x={28} y={221} fill="#051F51" fillOpacity={0.04} rx={4} />
      </g>
    </g>
    <rect width={359} height={249} x={0.5} y={0.5} stroke="#E2E2E5" rx={15.5} />
    <defs>
      <clipPath id="a">
        <rect width={360} height={250} fill="#fff" rx={16} />
      </clipPath>
      <pattern id="c" width={1} height={1} patternContentUnits="objectBoundingBox">
        <use xlinkHref="#d" transform="matrix(.00157 0 0 .00488 -.003 0)" />
      </pattern>
      <filter
        id="b"
        width={376}
        height={278}
        x={-8}
        y={-6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0509804 0 0 0 0 0.0862745 0 0 0 0 0.145098 0 0 0 0.04 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3109_6134" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_3109_6134" result="shape" />
      </filter>
    </defs>
  </svg>
))

LogoImage.displayName = 'logo-component'
export { LogoImage }
